import React from "react";

import { SectionBasicInfoList } from "./section-basic-info-list";
import { SectionTitle } from "./section-title";

interface DetailsPanelBasicInformationProps {
  id: string;
  fullName: string;
  grade: string;
  address: string;
}

export const DetailsPanelBasicInformation: React.FC<
  DetailsPanelBasicInformationProps
> = ({ id, fullName, grade, address }) => {
  return (
    <div>
      <SectionTitle title="Basic Info" />

      <SectionBasicInfoList
        items={[
          { type: "text", head: "Student ID", value: id || "--" },
          { type: "text", head: "Full Name", value: fullName || "--" },
          { type: "text", head: "Grade", value: grade || "--" },
          { type: "text", head: "Address", value: address || "--" },
        ]}
      />
    </div>
  );
};